module.exports = __webpack_public_path__ + "static/media/1_english.96a98bb0.png";